const ch = {
    common: {
        history: "varasemad versioonid"
    }
};
export default ch;



// WEBPACK FOOTER //
// ./src/i18n/langs/ee.js